import React from "react";
import {
  Drawer,
  DrawerOverlay,
  DrawerContent,
  DrawerCloseButton,
  DrawerHeader,
  DrawerBody,
  DrawerFooter,
  Text,
  Flex,
} from "@chakra-ui/react";
import Heading from "../Text/heading";
import CustomButton from "../Button/CustomButton";
import { ReactComponent as AlertTriangleIcon } from "../../assets/alert-triangle.svg";

const SidePanel = ({
  isOpen,
  onClose,
  btnRef,
  title,
  bodyText,
  buttonLabel,
  onClick,
  headingLabel,
  alert,
}) => {
  return (
    <Drawer
      isOpen={isOpen}
      placement="right"
      onClose={onClose}
      finalFocusRef={btnRef}
      size="sm"
    >
      <DrawerOverlay />
      <DrawerContent>
        <DrawerCloseButton color="#FFFFFF" marginTop="8px" />
        <DrawerHeader
          fontFamily="Nunito"
          fontSize="18px"
          lineHeight="32px"
          fontWeight="700"
          backgroundColor="#0E3665"
          color="#FFFFFF"
        >
          {title}
        </DrawerHeader>

        {alert ? (
          <DrawerBody padding={"0"}>
            <Flex justifyContent={"center"}>
              <Flex width={"88.57%"} flexDirection={"column"}>
                {" "}
                <Flex marginTop={"28px"}>
                  <AlertTriangleIcon />
                </Flex>
                <Heading headingLabel={headingLabel}></Heading>
                <Text
                  fontFamily={"Nunito"}
                  fontWeight={"400"}
                  fontSize={"13px"}
                  lineHeight={"22px"}
                  color={"#0E3665;"}
                >
                  {bodyText}
                </Text>
              </Flex>
            </Flex>
          </DrawerBody>
        ) : (
          <DrawerBody>
            <Heading headingLabel={headingLabel} />
            <Text
              fontFamily="Nunito"
              fontWeight="400"
              fontSize="13px"
              lineHeight="22px"
              color="#0E3665"
            >
              {bodyText}
            </Text>
          </DrawerBody>
        )}

        <DrawerFooter
          border="1px solid #ECEFF9"
          height="104px"
          justifyContent="center"
        >
          <CustomButton
            width="356px"
            backgroundColor={alert ? "#FF0000" : "#00E0FF"}
            onClick={onClick}
            buttonLabel={buttonLabel}
          />
        </DrawerFooter>
      </DrawerContent>
    </Drawer>
  );
};

export default SidePanel;
